import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import EngineF from "../../assets/EngineFlush.png";

const EngineFlush = () => {
  return (
    <>
      <SeoHead
        title="Engine Flush Service in Temecula | Advanced Automotive Smog"
        description="Engine flush service in Temecula that clears sludge and buildup before an oil change, helping restore smoother engine operation."
        path="/services/engine-flush"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Engine Flush"
          path="/services/engine-flush"
          description="Engine flush service in Temecula that clears sludge and buildup before an oil change, helping restore smoother engine operation."
          serviceType="Engine flush"
        />

        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - Mobile priority */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={EngineF}
                alt="Engine flush service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full md:w-1/2">

            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Engine Care
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Engine Flush
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Over time, sludge and contaminants build up inside your engine,
              reducing performance and shortening engine life. An engine flush
              clears out harmful deposits and restores smooth operation.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is an Engine Flush?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Before your oil change, we run a specialized cleaning agent
              through the engine to break down sludge, debris, and buildup.
              <br />
              <br />
              After the flush, we drain the old oil completely and refill your
              engine with premium fresh oil—restoring better lubrication,
              smoother performance, and improved fuel efficiency.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Removes sludge and harmful engine deposits</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improves engine performance and fuel economy</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Protects internal engine components from wear</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Includes premium oil replacement</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Restores engine health and long-term durability</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>

            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default EngineFlush;
